
/* injects from baggage-loader */
require('./wish-list-trim-list.component.html');

